import bottomCurve from "planets/pensatus/bottom-curve"
import trail from "planets/pensatus/trail"
import {
  PlanetHorizon,
  ShortPlanetHorizon,
  PlanetHorizonContainer,
  ShortPlanetHorizonContainer,
  PlanetHorizonTitle
} from "planets/pensatus/horizon"
import editProfileBackground from "planets/pensatus/pensatus-edit-profile-stones.svg"

export default {
  mainColor: "#741bb5",
  secondaryColor: "#77b8ff",
  bottomCurve: bottomCurve,
  trail: trail,
  knowledgeAreaSlide: { prev: "#ccc", next: "#ccc" },
  dailyMission: {
    questionSlider: { prev: "#4b1275", next: "#4b1275", arrowColor: "#fff" }
  },
  btnPrimary: { backgroundColor: "#ff9229", textColor: "#fff", shadowColor: "#ce6d10" },
  btnLink: { backgroundColor: "#741bb5", activeTextColor: "#ff9229" },
  gamificationBar: {
    white: { textColor: "#741bb5" },
    colored: { textColor: "#fff" }
  },
  header: { colored: { backgroundColor: "#8e3fac" } },
  horizon: {
    PlanetHorizon,
    ShortPlanetHorizon,
    PlanetHorizonContainer,
    ShortPlanetHorizonContainer,
    PlanetHorizonTitle
  },
  editProfileBackground: editProfileBackground,
  games: {
    title: "#6f82ee",
    border: "#6f82ee",
    detailsHeader: "#ffe256"
  }
}
